export const WorkoutMeta = {
  bindings: {
    workout: '<',
    member: '<',
  },

  template: `
    <ul class="list-unstyled d-flex justify-content-between p-3 mb-3 bg-gray-100 workout-meta small font-size-sm-base">
      <li ng-if="$ctrl.workout.meta.equipmentRequired">
        Equipment required
      </li>
      <li ng-if="$ctrl.workout.met">
        <i class="fa fa-lg icon-calories-burnt text-green-dark"></i>
        <workout-calories-burnt
          member="$ctrl.member"
          met="$ctrl.workout.met"
          total-time="$ctrl.workout.totalTime">
        </workout-calories-burnt> Cal
      </li>
      <li>
        <i class="fa fa-lg icon-time text-green-dark"></i>
        {{ $ctrl.workout.totalTimeMinutes }}
      </li>
      <li>
        <i class="fa fa-lg icon-location text-green-dark"></i>
        {{ $ctrl.workout.location }}
      </li>
    </ul>`,
};



// WEBPACK FOOTER //
// ./src/components/Workout/WorkoutMeta.js